const state = () => ({
    solicitation:false,
    org:{
        id: 1,
        creationDate: "2022-04-26T20:13:23.085Z",
        revokeDate: null,
        updateDate: "2022-04-27T14:38:56.382Z",
        tradeName: "",
        companyName: "",
        cnpj: "1111111111111111111111",
        facebook: null,
        instagram: "https://instagram.com/Eds",
        linkedIn: null,
        website: null,
        youtube: null,
        primaryColor: null,
        relatedContacts: [],
        idLogoLight: null,
        idLogoDark: null,
        idImageLogin: null,
        idLogoHeaderAdmin: null,
        idFavicon: null,
        idBanner: null,
    },
    emails:[],
    phons:[],
    images:{
        bannerMain: 'https://www.df.gov.br/wp-conteudo/themes/templategdf/img/destaque_conheca_brasilia.jpg',
        bannerDoubt: require(`@/assets/images/footerBanner.png`),
    },
    lastUpdatedDataOrg: null
});
export default state;
